export default {
  'Resize for': 'Ajustar el tamaño',
  'Add 10 videos at most': 'Se puede agregar un máximo de 10 vídeos. ',
}